<template>
  <div style="min-height: 450px" class="flex-column">
    <el-dialog top="2vh" v-if="replaceBadWord.show"
               :title="'Tin nhắn gửi đi có chứa '+replaceBadWord.items.length+' từ khóa nhạy cảm'" width="500px"
               :visible.sync="replaceBadWord.show" append-to-body>
      <div>
        <div>
          <div class="d-flex fw-bolder font-size-14 mb-3">
            <div class="w-150px">Từ cấm</div>
            <div class="flex-1">Từ thay thế</div>
            <div style="width: 60px"></div>
          </div>
          <div class="divider-custom"></div>
          <div style="max-height: 200px;overflow-y: auto;">
            <div v-for="(item,index) in replaceBadWord.items" :key="index">
              <div class="d-flex font-size-14 my-2">
                <div class="w-150px">
                  <div class="d-flex">
                    <div class="">{{ item.key }}</div>
                  </div>
                </div>
                <div class="flex-1">
                  <el-input placeholder="Nội dung thay thế" @input="handleInputReplace(item)"
                            v-model="item.replace"></el-input>
                </div>

              </div>
              <div class="divider-custom"></div>
            </div>
          </div>
        </div>
        <div class="my-2 ">Nội dung sau chỉnh sửa</div>
        <el-input
          ref="inputText"
          resize="none"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 5}"
          v-model="replaceBadWord.content"
          disabled
        />
        <div class="d-flex justify-content-end mt-2">
          <el-button size="sm" plain type="danger" @click="closeReplaceBadWord()">Hủy</el-button>
          <el-button size="sm" type="primary" @click="sendReplace()">Gửi tin nhắn</el-button>
        </div>
      </div>
    </el-dialog>
    <div v-if="profile">

      <div class="d-flex" style="height: 148px;position: relative">
        <el-image :src="profile.cover" fit="fill" class="w-100" />
        <div style="position: absolute;bottom: -30px;left: 0;right: 0;height: 80px">
          <div class="flex-column">
            <div class="d-flex justify-content-center font-size-17 fw-semibold">
              <el-avatar :src="profile.avatar" class="rounded-circle" alt="" :size="80" />
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 36px">
        <div class="d-flex justify-content-center font-size-20 fw-semibold">{{ profile.displayName }}</div>
      </div>
      <div class="d-flex justify-content-center mt-2" v-if="!showInput">
        <el-button class="" size="mini" type="primary" plain @click="showMessageInput()">Nhắn tin
        </el-button>

        <el-button class="" size="mini" type="danger" :disabled="profile.isBlocked !== null && profile.isBlocked === 1"
                   plain
                   v-if="requestFriend.is_requested===1" @click="undoFriendRequest()">Thu hồi
        </el-button>
        <el-button class="" size="mini" :disabled="profile.isBlocked !== null && profile.isBlocked === 1" plain
                   v-else-if="profile.isFr===0" @click="showAddFriend()">Kết
          bạn
        </el-button>
      </div>
      <div v-if="showInput">
        <div v-if="selectType=='friend'" class="mt-4">
          <el-input v-model="content" type="textarea" resize="none" :rows="4" placeholder="Nhập lời mời kết bạn"
                    :maxlength="150" show-word-limit />
        </div>
        <div v-if="selectType=='message'" class="mt-4">
          <el-input class="text-break" v-model="content" type="textarea" resize="none" :rows="4"
                    placeholder="Nhập nội dung tin nhắn" />
        </div>
      </div>
      <div class="flex-column mt-3" v-else>

        <div class="font-size-16 fw-semibold">Thông tin cá nhân</div>
        <div class="d-flex mt-1">
          <div class="w-100px mx-1 text-secondary">Giới tính:</div>
          <div class="flex-1"> {{ profile.gender === 0 ? "Nam" : "Nữ" }}</div>
        </div>
        <div class="d-flex mt-1">
          <div class="w-100px mx-1 text-secondary">Ngày sinh:</div>
          <div class="flex-1"> {{ profile.sdob }}</div>
        </div>
        <div class="d-flex mt-1" v-if="(isAdminUser()|| app.showPhoneInContact)">
          <div class="w-100px mx-1 text-secondary">Số điện thoại:</div>
          <div class="flex-1"> {{ profile.phoneNumber }}</div>
        </div>
      </div>

      <div v-if="showInput">
        <div class="divider-custom" />
        <div class="d-flex justify-content-end mt-4 mb-2">
          <el-button size="mini" plain type="primary" @click="showInfo()">Thông tin</el-button>
          <el-button size="mini" type="danger" @click="undoFriendRequest()"
                     v-if="selectType=='friend' && requestFriend.is_requested===1">Thu hồi
          </el-button>
          <el-button size="mini" type="primary" @click="addFriend()"
                     v-else-if="selectType=='friend' && profile.isFr === 0">Kết bạn
          </el-button>

          <el-button size="mini" type="primary" @click="sendMessage()" v-else>Gửi</el-button>
        </div>
      </div>
      <div class="mt-3 divider-custom-zalo"></div>
      <div class="mt-3">
        <div @click="handleActionBlock()" v-bind:class="!profile.isBlocked?'text-danger':''"
             class="py-2 user_block pointer rounded-2"><i class="el-icon-lock mx-2" />
          {{ !profile.isBlocked ? "Chặn tin nhắn" : "Bỏ chặn tin nhắn" }}
        </div>
        <div v-if="profile.isFr===1"
             @click="removeFriend()" class="py-2 user_block pointer rounded-2"><i class="el-icon-delete mx-2" />
          Xoá khỏi danh sách bạn bè
        </div>
      </div>
    </div>
    <div v-else class="d-flex justify-content-center mt-8">Không tìm thấy thông tin</div>
  </div>
</template>

<script>
export default {
  name: "ProfileInfoPopup",
  props: ["conversation", "data"],

  data() {
    return {
      showInput: false,
      selectType: "",
      content: "",
      requestFriend: {},
      profile: {},
      replaceBadWord: {
        show: false,
        items: [],
        content: ""
      }
    };
  },
  watch: {
    data: {
      handler: function() {
        this.profile = JSON.parse(JSON.stringify(this.data));
        this.showInput = false;
      },
      deep: true
    }
  },

  methods: {
    removeFriend() {
      let req = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId
      };
      this.$http.post("/api/contact/removeFriend", req).then((resp) => {
        if (resp.data.error_code === 0) {
          this.alert("success", "Xoá bạn thành công");
          this.closeDialog();
        }
      });
    },
    handleActionBlock() {
      if (this.profile.isBlocked === 1) this.actionUser("unblock");
      else this.actionUser("block");
    },

    actionUser(action) {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId,
        action: action,
        conversationId: this.conversation.id
      };
      this.$http.post("/api/message/block", request).then((resp) => {
        if (resp?.data?.error_message !== "Successful.") return this.alert("error", "Có lỗi xảy ra vui lòng thử lại");
        if (action === "block") {
          this.profile.isBlocked = 1;
          this.alert("success", "Chặn thành công, người dùng này sẽ không thể gửi tin nhắn tới bạn");
        } else {
          this.profile.isBlocked = 0;
          this.alert("success", "Bỏ chặn thành công");
        }
        this.$bus.$emit("handleBlock", { action: action, toId: this.conversation.toId });
      });
    },

    undoFriendRequest() {
      this.$http.get("/api/contact/undoFriendRequest", {
        params: {
          accountId: this.conversation.accountId,
          userId: this.conversation.toId
        }
      }).then((resp) => {
        if (resp.data.error_code === 0) {
          this.friendRequestStatus();
        }
        if (resp.data.error_code !== 0) {
          this.alertError(resp.data.error_message);
        }
      });
    },

    async addFriend() {
      this.visibleRequestFriend = false;
      this.$http.get("/api/contact/addFriend", {
        params: {
          msg: this.content,
          userId: this.conversation.toId,
          accountId: this.conversation.accountId
        }
      }).then(async (resp) => {
        if (resp.data.error_code === 0) {
          let data = await this.friendRequestStatus();
          if (data.is_requested === 1) {
            this.alert("success", "Gửi kết bạn thành công");
          } else {
            this.alert("error", "Người dùng này đã từ chối trước đó");
          }
        } else if (resp.data.error_code === 222) {
          this.$set(this.profile, "isFr", 1);
        } else if (resp.data.error_code !== 0) {
          return this.alert("error", resp.data.error_message);
        }
        this.closeDialog();
      });
    },
    showAddFriend() {
      this.content = "Xin chào " + this.profile.displayName + ", kết bạn với mình nhé!";
      this.selectType = "friend";
      this.showInput = true;
    },
    showInfo() {
      this.showInput = false;
    },
    showMessageInput() {
      this.content = "";
      this.selectType = "message";
      this.showInput = true;
    },
    getProfileInfo() {
      this.profile = null;
      this.$http.get("/api/message/getProfileInfo", {
        params: {
          accountId: this.conversation.accountId,
          profileId: this.conversation.toId
        }
      }).then((reps) => {
        this.profile = reps.data.data.changed_profiles[this.conversation.toId];
        if (this.profile.isFr === 0) {
          this.friendRequestStatus();
        }
      });
    },
    closeDialog() {
      this.$bus.$emit("closeProfile");
    },
    sendMessage() {
      if (!this.content) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }
      let items = this.filterCharacter();
      if (items.length > 0) {
        this.replaceBadWord.show = true;
        this.replaceBadWord.items = items;
        this.replaceBadWordContent();
      } else {
        this.senMesV2();
      }
    },
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.conversation.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map(item => [item[key], item])).values()];
      return unique;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr()) {

          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.content;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    filterCharacter() {
      let items = [];
      let check = true;
      let fil = this.app.accountSetting.filter(p => p.accountId == this.conversation.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = this.content;
        let arr = text.split(" ");
        if (this.filterCharacterArr() && this.filterCharacterArr().length > 0 && arr.length > 0) {
          for (let item of this.filterCharacterArr()) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    senMesV2(keys, replace) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        groupId: this.conversation.toId,
        message: this.content,
        bannedKeyword: keys ? keys : [],
        replace: replace
      };
      let url = "/api/message/sms";
      if (this.conversation.group) {
        url = "/api/message/groupMsg";
      }
      this.$http.post(url, request).then((resp) => {

        if (resp.data.error_code === 0) {
          this.alert("success", "Đã gửi tin nhắn");
        } else if (resp.data.error_code !== 0) {
          this.alert("error", resp.data.error_message);
        }
      });
      this.closeReplaceBadWord();
    },
    sendReplace() {
      this.content = this.replaceBadWord.content;
      this.senMesV2(this.replaceBadWord.items.map((k) => {
        return k.key;
      }), true);
    },
    closeReplaceBadWord() {
      this.content = "";
      this.showInput = false;
      this.replaceBadWord.show = false;
    },
    async friendRequestStatus() {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId
      };
      return await this.$http.post("/api/conversation/friendRequestStatus", request).then((resp) => {
        if (resp.data.error_code === 0) {
          this.requestFriend = resp.data.data;
        }
        return resp.data.data;
      });
    }
  },

  created() {
    if (this.data) {
      this.profile = JSON.parse(JSON.stringify(this.data));
      if (this.profile.isFr === 0) {
        this.friendRequestStatus();
      }
      return;
    }
    if (this.conversation) {
      this.getProfileInfo();
    }
  }
};
</script>

<style scoped>
.user_block:hover {
  background-color: #eff2f7;
}
</style>
